var exports = {
  "W9": "testimonialBackgroundImageShape__Tx2evY",
  "P1": "productivity__ww3mYp",
  "kb": "left__H7sdCD",
  "pG": "right__pzJOsq",
  "mj": "collaboration__wnk-lN",
  "ai": "ai__ZsisdZ",
  "rG": "security__-Cf6Q3",
  "s2": "enterprise__qCkf3l",
};

module.exports = exports;
